import React from 'react';
import './Footer.style.css';
import Facebook from 'assets/svg/facebook_w.svg';
import Instagram from 'assets/svg/insta_w.svg';
import Youtube from 'assets/svg/youtube_w.svg';
import Naver from 'assets/svg/naver_w.svg';
import Logo from 'assets/svg/logo_w.svg';
import Call from 'assets/svg/call_w.svg';
import Mail from 'assets/svg/mail_w.svg';
import Bank from 'assets/svg/bank_w.svg';
import Qr from 'assets/svg/qr_code_w.svg';
import QrCode from 'assets/qrcode.svg';
import { Collapse02, Link, Text } from 'components';
import { Select } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import Collapse03 from '../Collapse03';
const FAMILY_SITE = [
  {
    label: '제이엠커피그룹',
    value: 'https://jmcoffee.co.kr/',
  },
];

const FOOTER_LINK = [
  {
    label: '회사소개',
    value: `https://jmcoffee.co.kr/`,
    type: '_blank',
  },
  {
    label: '공지사항',
    value: '/#/cs/notice',
    type: '_self',
  },
  {
    label: '이용약관',
    value: '/#/policy/use',
    type: '_self',
  },
  {
    label: '개인정보처리방침',
    value: '/#/policy/privacy',
    type: '_self',
  },
  {
    label: '환불약관',
    value: '/#/policy/refund',
    type: '_self',
  },
  {
    label: '충전식 상품권 약관',
    value: '/#/policy/charge',
    type: '_self',
  },
  {
    label: '위치정보 약관',
    value: '/#/policy/location',
    type: '_self',
  },
  {
    label: '선물하기 약관',
    value: '/#/policy/present',
    type: '_self',
  },
  {
    label: '렌탈 서비스 약관',
    value: '/#/policy/rental',
    type: '_self',
  },
  {
    label: '정기배송 서비스 약관',
    value: '/#/policy/subscription',
    type: '_self',
  },
];

/**
 * ==============
 * 소셜 버튼 컴포넌트
 * ==============
 */
const LinkButton = ({ children, type = '', url = '', isWebView = false }) => {
  const openUrl = () => {
    if (!isWebView) {
      window.open(url);
    } else {
      window.ReactNativeWebView.postMessage(
        `${JSON.stringify({ type: 'social', social: type })}`,
      );
    }
  };

  return (
    <button
      style={{
        color: '#FFFFFF',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
      }}
      onClick={() => openUrl()}
    >
      {children}
    </button>
  );
};

const Footer = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { isWebView = false } = props;

  /* ===== State ===== */
  const [isOpen, setIsOpen] = React.useState(false);
  const [screenSize, setScreenSize] = React.useState(document.body.clientWidth);

  const toggleModal = () => setIsOpen(!isOpen);
  const closeModal = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      setIsOpen(false);
    }
  };
  React.useEffect(() => {
    const call = (e) => {
      setScreenSize(document.body.clientWidth);
    };

    window.addEventListener('resize', call);

    return () => {
      window.removeEventListener('resize', call);
    };
  }, []);
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   *
   * @param {*} type
   * @param {*} url
   */
  const handleOpenUrl = (type, url) => {
    switch (type) {
      case '_blank': {
        if (isWebView) {
          window.ReactNativeWebView.postMessage(
            `${JSON.stringify({ type: 'open', url })}`,
          );
        } else {
          window.open(url);
        }
        break;
      }
      case '_self': {
        if (isWebView) {
          window.ReactNativeWebView.postMessage(
            `${JSON.stringify({ type: 'navigation', url })}`,
          );
        } else {
          window.location.href = url;
        }
        break;
      }
      default:
        break;
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="jm_footer_wrap">
      {/* ===== Top Start ====== */}
      <div className="jm_footer_top">
        <div className="jm_footer_container">
          <ul className="jm_footer_social">
            <li>
              <LinkButton
                type={'instagram'}
                url={'https://www.instagram.com/jmcoffee.official/'}
                isWebView={isWebView}
              >
                <img src={Instagram} alt="instagram" width={32} />
              </LinkButton>
            </li>
            <li>
              <LinkButton
                type={'facebook'}
                url={'https://www.facebook.com/jmcoffeeroasters/?locale=ko_KR'}
                isWebView={isWebView}
              >
                <img src={Facebook} alt="facebook" width={32} />
              </LinkButton>
            </li>
            <li>
              <LinkButton
                type={'youtube'}
                url={'https://www.youtube.com/channel/UCsyEkDqNdCaH29DHvLAiRHg'}
                isWebView={isWebView}
              >
                <img src={Youtube} alt="youtube" width={32} />
              </LinkButton>
            </li>
            <li>
              <LinkButton
                type={'naver'}
                url={'https://blog.naver.com/jmcoffee_official'}
                isWebView={isWebView}
              >
                <img src={Naver} alt="youtube" width={32} />
              </LinkButton>
            </li>
          </ul>

          <div className="jm_footer_family_site">
            <Select
              value={null}
              options={FAMILY_SITE}
              style={{
                width: '100%',
                background: '#000000',
                border: '0.7px solid #FFFFFF',
                color: '#FFFFFF',
              }}
              placeholder={
                <Text color={'#FFFFFF'} size={14} weight={300}>
                  Family Site
                </Text>
              }
              variant="borderless"
              suffixIcon={<CaretDownFilled style={{ color: '#FFFFFF' }} />}
              onChange={(e) => handleOpenUrl('_blank', e)}
            />
          </div>
        </div>
      </div>
      {/* ===== Top End ====== */}

      {/* ===== Bottom Start ===== */}
      <div className="jm_footer_bottom">
        <div className="jm_footer_container">
          {/* ===== Bottom Left Start ===== */}
          <div className="jm_footer_bottom_left">
            {/* Logo */}
            <div className="jm_footer_bottom_left_logo">
              <img
                src={Logo}
                alt="로고"
                style={{ width: '100%', maxWidth: 200 }}
              />
            </div>
            {/*  */}
            <ul className="jm_footer_bottom_left_link">
              {screenSize >= 768
                ? FOOTER_LINK.map((link, index) => (
                    <li key={`link-${link.label}-${index}`}>
                      {isWebView ? (
                        <p
                          className={'s18'}
                          style={{ color: ' #FFFFFF', cursor: 'pointer' }}
                          onClick={() => handleOpenUrl(link.type, link.value)}
                        >
                          {link.label}
                        </p>
                      ) : (
                        <Link
                          className={'s18'}
                          color={'#FFFFFF'}
                          url={link.value}
                          target={link.type}
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))
                : null}
            </ul>

            {/*  */}
            {screenSize >= 768 ? (
              <div className="jm_footer_bottom_left_info">
                <p className="s13">
                  <div className="margin_right">
                    <strong>업체명</strong> : 주식회사 제이엠커피그룹
                  </div>
                  <div>
                    <strong>사업장등록번호</strong>: 621-86-12651
                  </div>
                </p>
                <p className="s13">
                  <div>
                    <strong>주소</strong> : [46079] 부산광역시 기장읍 대변3길 8
                    제이엠커피로스터스
                  </div>
                </p>
                <p className="s13">
                  <div className="margin_right">
                    <strong>통신판매업신고번호</strong> : 2022-부산기장-0221
                  </div>
                  <div>
                    <strong>개인정보보호책임자</strong> : 이화림
                  </div>
                </p>
              </div>
            ) : (
              <Collapse03
                title={'정책 및 약관 '}
                titleStyle={{
                  fontWeight: '500px',
                  fontSize: '16px',
                }}
                children={FOOTER_LINK.map((link, index) => (
                  <li key={`link-${link.label}-${index}`}>
                    {isWebView ? (
                      <p
                        style={{ color: ' #FFFFFF', cursor: 'pointer' }}
                        onClick={() => handleOpenUrl(link.type, link.value)}
                      >
                        {link.label}
                      </p>
                    ) : (
                      <Link
                        color={'#FFFFFF'}
                        url={link.value}
                        target={link.type}
                        size={12}
                        weight={300}
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
                contentStyle={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px',
                  lineHeight: '24px',
                  padding: 0,
                  margin: 0,
                }}
                defaultOpened={false}
              ></Collapse03>
            )}
          </div>
          {/* ===== Bottom Left End ===== */}

          {/* ===== Bottom Right Start ===== */}
          <div className="jm_footer_bottom_right">
            <ul className="jm_footer_bottom_right_cs">
              <li
                className="pc"
                onClick={toggleModal}
                style={{ cursor: 'pointer' }}
              >
                <div>
                  <img src={Qr} alt="모바일 앱 다운로드" width={20} />
                </div>
                <div>
                  <p className="s15" style={{ fontWeight: 300 }}>
                    모바일 앱 다운로드
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <img src={Call} alt="상담전화" width={20} />
                </div>
                <div>
                  <p className="s30" style={{ fontWeight: 700 }}>
                    1899-0820
                  </p>
                  <p className="s15" style={{ fontWeight: 300 }}>
                    월~금 (평일)
                    <br /> 10:00am ~ 17:00pm
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <img src={Mail} alt="이메일" width={20} />
                </div>
                <div>
                  <p className="s15" style={{ fontWeight: 300 }}>
                    jmcoffeecs@jmcoffee.co.kr
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <img src={Bank} alt="계좌번호" width={20} />
                </div>
                <div>
                  <p className="s15" style={{ fontWeight: 300 }}>
                    [ 하나은행 ] (주) 제이엠커피그룹
                  </p>
                  <p className="s25" style={{ fontWeight: 700 }}>
                    102-910073-84504
                  </p>
                </div>
              </li>
            </ul>
          </div>
          {/* ===== Bottom Right End ===== */}

          {/* Mobile Logo */}
          <div className="jm_footer_bottom_mobile_logo">
            {/* <img
              src={Logo}
              alt="로고"
              style={{ width: '100%', maxWidth: 306 }}
            /> */}
            {screenSize <= 768 && (
              <Collapse03
                titleImage={Logo}
                children={
                  <div className="jm_footer_bottom_left_info">
                    <div className="mobile">
                      <p className="s13">
                        <div className="margin_right">
                          <strong>업체명</strong> : 주식회사 제이엠커피그룹
                        </div>
                        <div>
                          <strong>사업장등록번호</strong>: 621-86-12651
                        </div>
                      </p>
                      <p className="s13">
                        <div>
                          <strong>주소</strong> : [46079] 부산광역시 기장읍
                          대변3길 8 제이엠커피로스터스
                        </div>
                      </p>
                      <p className="s13">
                        <div className="margin_right">
                          <strong>통신판매업신고번호</strong> :
                          2022-부산기장-0221
                        </div>
                        <div>
                          <strong>개인정보보호책임자</strong> : 이화림
                        </div>
                      </p>
                    </div>
                  </div>
                }
                contentStyle={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  padding: 0,
                  margin: 0,
                }}
                defaultOpened={false}
              ></Collapse03>
            )}
          </div>
        </div>
      </div>
      {/* ===== Bottom End ===== */}

      {isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className={`modal-content ${isOpen ? 'fade-in' : 'fade-out'}`}>
            <img src={QrCode} alt="QR 코드" style={{ width: '100%' }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
